export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";